export default __webpack_public_path__ + "static/media/MFZB.c44d1199.svg";